// info
//@ts-ignore
import Time from '../media/img/mainInfoImg/quyality.png';
//@ts-ignore
import Quality from '../media/img/mainInfoImg/quyality.png';
//@ts-ignore
import Price from '../media/img/mainInfoImg/price.png';
//@ts-ignore
import Brain from '../media/img/mainInfoImg/brain.png';





//foter
//@ts-ignore
// import disc from '../media/img/footerInfo/discordFooter.png';
//@ts-ignore
import inst from '../media/img/footerInfo/instaFoote.png';
//@ts-ignore
// import gmail from '../media/img/footerInfo/gmailFooter.png';
//@ts-ignore
import telega from '../media/img/footerInfo/tgFooter.png';




//allProject
import noProjectsRu from'../media/img/projects/yourProjectRu.png';
// import noProjectsEn from'../media/img/projects/yourProjectEn.png';
import blackLogoab84f380 from'../media/img/projects/blackLogo.ab84f380.png';
import work2 from'../media/img/projects/ArmConsulting.png';




// header
export const header_ls = [
    {
        "textHref" : "Обо мне",  //Info about me
        "href" : "#Info_about_me_h2"
    },
    {
        "textHref" : "Мои навыки",  //My scills
        "href" : "#Scills_h2"
    },
    {
        "textHref" : "Последние проекты",  //Last projects
        "href" : "#Slider_h2"
    },
    {
        "textHref" : "Все проекты",  //All projects
        "href" : "#All_projects_h2"
    },
    {
        "textHref" : "Контакты",  //Contacts
        "href" : "#Contacts_h2"
    }
]
export const header_lsBurger = [
    {
        "textHref" : "Обо мне",  //Info about me
        "href" : "#Info_about_me_h2"
    },
    {
        "textHref" : "Мои навыки",  //My scills
        "href" : "#Scills_h2"
    },
    {
        "textHref" : "Последние проекты",  //Last projects
        "href" : "#Slider_h2"
    },
    {
        "textHref" : "Все проекты",  //All projects
        "href" : "#All_projects_h2"
    },
    {
        "textHref" : "Контакты",  //Contacts
        "href" : "#Contacts_h2"
    },
]


//all_projects
export const webData = 
[
    {
        web: 'https://vubo.herokuapp.com', 
        name: 'Сайт университета',
        altName: 'work #1',
        imgName: blackLogoab84f380
    },
    {
        web: 'https://arm-consulting.kiev.ua/#/', 
        name: 'Arm Consulting',
        altName: 'work #2',
        imgName: work2
    },
    {
        web: '#', 
        name: '',
        altName: 'work #3',
        imgName: noProjectsRu
    },
    {
        web: '#', 
        name: '',
        altName: 'work #4',
        imgName: noProjectsRu
    },
    {
        web: '#', 
        name: '',
        altName: 'work #5',
        imgName: noProjectsRu
    },
    {
        web: '#', 
        name: '',
        altName: 'work #6',
        imgName: noProjectsRu
    },
]
//info
export const infoMap = [
    {    
        imgsrc: Time,
        imgalt: 'Time',
        divTextInfo: 'Время',// - время Time
    },
    {
        imgsrc: Quality,
        imgalt: 'Quality',
        divTextInfo: 'Качество',// - качество Quality
    },
    {
        imgsrc: Price,
        imgalt: 'Price',
        divTextInfo: 'Цена',// - цена Price
    },
    {
        imgsrc: Brain,
        imgalt: 'Logics',
        divTextInfo: 'Логика'// - логика Logics
    }
]

// //scillsAll

export const dataScills = [
    {
        texts: 'HTML + CSS + JS',
        percents: '80',
    },
    {
        texts: 'REACT + REDUX',
        percents: '75',
    },
    {
        texts: 'PHP + MYSQL',
        percents: '65',
    },
    {
        texts: 'C++',
        percents: '40',
    },
    {
        texts: 'C#',
        percents: '60',
    },
    {
        texts: 'PYTHON',
        percents: '70',
    },
    {
        texts: 'PHOTOSHOP + ILLUSTRATOR',
        percents: '65',
    },
    {
        texts: 'FIGMA',
        percents: '85',
    },
]



//footer
export const footerConst = [ 
    // {
    //     footerImg: disc,
    //     footerSite: '#',
    // },
    {
        footerImg: telega,
        footerSite: 'https://t.me/brock_squad#',
        altFooter: 'Telegram'
    },
    // {
    //     footerImg: gmail,
    //     footerSite: '#',
    // },
    {
        footerImg: inst,
        footerSite: 'https://www.instagram.com/mr.brock19/',
        altFooter: 'Instagram'
    },
]